interface IBffErrorResponse {
  response?: { data?: { data?: { error?: { code?: unknown } } } };
}

export const bffErrorCode = (error: unknown): string => {
  const code = (error as IBffErrorResponse | null)?.response?.data?.data?.error?.code;

  return code === undefined || code === null ? '' : String(code);
};
